import { AddressStreet, BusinessInfo, Owner } from "@1games-ru/region-shared/dist/types/bank/bank";
import formatPrice from "@/core/helpers/formatPrice";

function getOwnerName(owner: Owner) {
  if (!owner.firstName && !owner.lastName) {
    return "Нет владельца";
  }

  return `${owner.firstName} ${owner.lastName}`;
}

function getAddress(address: AddressStreet) {
  return `${address.streetName} ${address.index}`;
}

function ATMInfoBlock({ title, value }: { title: string; value: string }) {
  return (
    <div className="flex flex-col leading-tight text-center">
      <div className="font-bold text-16 text-dark-800">{title}</div>
      <div className="font-normal text-14 text-sbank-muted">{value}</div>
    </div>
  );
}

export function BankATMFooter({
  atmId,
  businessInfo,
}: {
  atmId: number;
  businessInfo?: BusinessInfo;
}) {
  if (!businessInfo) {
    return null;
  }

  return (
    <footer className="flex flex-col gap-6">
      <div className="flex flex-col gap-1">
        <div className="text-sbank-muted font-bold">Информация о банкомате:</div>
        <div className="inline-flex w-fit text-12 font-bold px-2 py-1 rounded-xl text-sbank-muted bg-sbank-muted/20">
          sID: {atmId}
        </div>
      </div>

      <div className="flex justify-between">
        <ATMInfoBlock title={getOwnerName(businessInfo.owner)} value="Владелец банкомата" />

        <div className="flex gap-8">
          <ATMInfoBlock
            title={`Банкомат №${businessInfo.id}`}
            value={getAddress(businessInfo.addressStreet)}
          />
          <ATMInfoBlock
            title={`${formatPrice(businessInfo.businessPrice)} ₽`}
            value="Гос.цена банкомата"
          />
        </div>
      </div>
    </footer>
  );
}
